<div *ngIf="dadosUnidade" class="dados-unidade">
  <div>
    <b>{{ dadosUnidade.clienteNome }}</b>
    <span>
      <b>Unidade:</b> {{ dadosUnidade.matricula }}-{{
        dadosUnidade.digitoVerificador
      }}
      -
      {{ dadosUnidade.enderecoCompleto }}
    </span>
  </div>
  <div>
    <span> Caso essa não seja sua unidade clique em </span>
    <p-button
      className="p-button-danger"
      size="small"
      label="Sair"
      severity="danger"
      (onClick)="sairHandle()"
    ></p-button>
  </div>
</div>
